import { Media, Post, PostResponse, SiteInfo } from "@/models/Cms";
import { getNewContent, getPopularContent, getPostByCategory, getPostBySearch, getPostBySlug, getSiteContentByTitle } from "@/service/post";


export async function loadNewContent(pageSize = 3): Promise<Post[]> {
    return await (await getNewContent(pageSize)).data.data
}

export async function loadPopularContent(pageSize = 3): Promise<Post[]> {
    return await (await getPopularContent(pageSize)).data.data
}

export async function queryPostBySlug(slug: string): Promise<Post | undefined> {
    const posts = await (await getPostBySlug(slug)).data.data
    if (posts.length > 0) {
        return posts[0];
    }
}

export async function getContentByCategory(category: string | undefined, page = 1): Promise<PostResponse> {
    const postResponse = await (await getPostByCategory(category, page)).data;
    return postResponse;
}

export async function getContentBySearch(search: string, page = 1): Promise<PostResponse> {
    const postResponse = await (await getPostBySearch(search, page)).data;
    return postResponse;
}

export async function getSiteInfoByTitle(title: string): Promise<SiteInfo | undefined> {
    const siteInfoResponse = await (await getSiteContentByTitle(title)).data;
    if (siteInfoResponse.data.length > 0) {
        return siteInfoResponse.data[0];
    }
}

export function getLargestMediaUrl(media: Media): string {
    if (!media || !media.attributes) return '';

    const { url, formats } = media.attributes;

    // Return largest available in descending order
    if (formats?.large?.url) return formats.large.url;
    if (formats?.medium?.url) return formats.medium.url;
    if (formats?.small?.url) return formats.small.url;
    if (formats?.thumbnail?.url) return formats.thumbnail.url;

    // Fallback to original
    return url;
}